import type { RestaurantDetails } from "@/API";
import type { FC } from "react";
import Text from "../Text";

type Props = {
  restaurant: RestaurantDetails | null;
};

const RestaurantMenu: FC<Props> = ({ restaurant }) => {
  if (!restaurant) return null;

  const { menuItems } = restaurant;
  const itemsByCategory: { [key: string]: typeof menuItems } = {};

  for (const item of menuItems) {
    if (item?.categoryName) {
      itemsByCategory[item.categoryName] = itemsByCategory[item.categoryName]
        ? [...itemsByCategory[item.categoryName], item]
        : [item];
    }
  }

  return (
    <>
      {Object.entries(itemsByCategory).map(([categoryName, items]) => (
        <div key={categoryName} className="mt-[24px] @container">
          <Text fontWeight={600} fontSize={14}>
            {categoryName}
          </Text>
          <div className="grid @md:grid-cols-3 @xl:grid-cols-4 @6xl:grid-cols-5 gap-x-[16px] gap-y-[24px] mt-[24px]">
            {items.map((item) => {
              if (!item) return null;

              return (
                <div
                  className="bg-[white] rounded-[12px] p-[16px]"
                  key={`${item.categoryName}-${item.name}`}
                >
                  <img
                    src={item?.imageUrl ?? undefined}
                    alt={item.name}
                    className="mb-[12px] aspect-3/2 object-cover"
                  />
                  <div className="flex flex-col gap-[4px]">
                    <Text fontWeight={600} fontSize={14}>
                      {item.name}
                    </Text>
                    <Text fontWeight={400} fontSize={14}>
                      {`${(item.price / 100).toFixed(2)}  ${restaurant.currencySymbol}`}
                    </Text>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
};

export default RestaurantMenu;
